var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dark-nav',{attrs:{"active":_vm.active}}),_vm._t("default"),_c('setting'),_c('Footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }